import axios from "axios";
import { baseUrl } from "../utils/constants";
import { getAdminToken } from "../auth/adminSession";

export const postData = async (url, data, addToken, lang) => {
  const config = addToken
    ? {
        headers: {
          Authorization: getAdminToken(),
          ...(lang ? { lang } : {}),
        },
      }
    : {};
  return await axios.post(baseUrl + url, data, config);
};
export const putDataToken = async (url,data, addToken) => {
  const config = addToken
    ? {
        headers: {
          Authorization: getAdminToken(),
        },
      }
    : {};
  return await axios.put(baseUrl + url,  data, config);
};

export const getData = async (url, addToken, lang) => {
  const config = addToken
    ? {
        headers: {
          Authorization: getAdminToken(),
          lang: lang || "all"
        },
      }
    : {};
  return await axios.get(baseUrl + url, config);
};

export const getBlobData = async (url, addToken, lang, options = {}) => {
  const config = addToken
    ? {
        headers: {
          Authorization: getAdminToken(),
          ...(lang ? { lang } : {}),
        },
        responseType: "blob",
        ...(options.signal ? { signal: options.signal } : {}),
      }
    : {
        responseType: "blob",
        ...(options.signal ? { signal: options.signal } : {}),
      };
  return await axios.get(baseUrl + url, config);
};

export const deleteDataToken = async (url) => {
  const config = {
    headers: {
      Authorization: getAdminToken(),
    },
  };
  return await axios.delete(baseUrl + url, config);
};



export const patchDataToken = async (url, data, addToken = true, lang) => {
  const config = addToken
    ? {
        headers: {
          Authorization: getAdminToken(),
          ...(lang ? { lang } : {}),
        },
      }
    : {};
  return await axios.patch(baseUrl + url, data, config);
};
